import { SectionRegistrationAttributes } from '../builders/section_registraion_attributes_builder';
import { Datasource, IDatasource } from 'utility-ng-kernel';

export interface ISectionRegistrationAttributesDatasource extends IDatasource<SectionRegistrationAttributes> {}

angular
  .module('capability-ng-scheduler')
  .factory('ngSectionRegistrationAttributesDatasource', (): ISectionRegistrationAttributesDatasource => {
    return new Datasource({
      builderType: SectionRegistrationAttributes
    });
  });



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/registration_attributes/datasources/section_registration_attributes_datasource.ts